import type { LucideIcon } from 'lucide-react';
import { ClipboardList, Compass, Globe2, Layers, Map, Star } from 'lucide-react';

export interface DocumentationNavItem {
  id: string;
  title: string;
  description: string;
  path: string;
  icon: LucideIcon;
}

export const documentationNav: DocumentationNavItem[] = [
  {
    id: 'overview',
    title: 'Overview',
    description: 'One platform, from data to decisions — how it fits together',
    path: '',
    icon: Compass,
  },
  {
    id: 'external-sources',
    title: 'Data Sources',
    description: 'Where our data comes from, grouped by what we can share',
    path: 'external-sources',
    icon: Globe2,
  },
  {
    id: 'methodologies',
    title: 'Methodologies',
    description: 'Every analysis method, live from the registry',
    path: 'methodologies',
    icon: Layers,
  },
  {
    id: 'project-showcase',
    title: 'Project Showcase',
    description: 'SB470: one end-to-end rollout, start to finish',
    path: 'showcase',
    icon: Star,
  },
  {
    id: 'maphub',
    title: 'MapHub',
    description: 'A door to maps — browse in-browser or via QGIS',
    path: 'maphub',
    icon: Map,
  },
  {
    id: 'work-in-progress',
    title: 'Work in Progress',
    description: "Honest roadmap: what's live, building, and exploring",
    path: 'work-in-progress',
    icon: ClipboardList,
  },
];
